<template>
  <main-container v-if="isBasicRoute">
    <a-card>
      <div class="status_list" v-if="!userId">
        <a-button class="item" :type="activeIndex == 1 ? 'primary' : ''" @click="loadRangeOrderList(1)">
          新订单 {{ orderCount.order_new }}
        </a-button>
        <a-button class="item" :type="activeIndex == 2 ? 'primary' : ''" @click="loadRangeOrderList(2)">
          已获准 {{ orderCount.order_commit }}
        </a-button>
        <a-button class="item" :type="activeIndex == 3 ? 'primary' : ''" @click="loadRangeOrderList(3)">
          已发出 {{ orderCount.order_send }}
        </a-button>
        <a-button class="item" :type="activeIndex == 4 ? 'primary' : ''" @click="loadRangeOrderList(4)">
          到达目的地 {{ orderCount.order_arrive }}
        </a-button>
        <a-button class="item" :type="activeIndex == 5 ? 'primary' : ''" @click="loadRangeOrderList(5)">
          已配送 {{ orderCount.order_distribution }}
        </a-button>
        <a-button class="item" :type="activeIndex == 6 ? 'primary' : ''" @click="loadRangeOrderList(6)">
          已完成 {{ orderCount.order_success }}
        </a-button>
        <a-button class="item" :type="activeIndex == 7 ? 'primary' : ''" @click="loadRangeOrderList(7)">
          已取消 {{ orderCount.order_cancel }}
        </a-button>
        <a-button class="item" :type="activeIndex == 8 ? 'primary' : ''" @click="loadRangeOrderList(8)">
          已退款 {{ orderCount.order_refund }}
        </a-button>
      </div>
      <div class="table-query" v-if="!userId">
        <a-form-model ref="queryFormRef" :model="queryForm" :rules="queryFormRules" :label-col="{ span: 5 }">
          <a-row :gutter="12">
            <a-col :md="6" style="min-width: 320px">
              <a-form-model-item label="订单编号">
                <a-input v-model="queryForm.order_id"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col style="min-width: 320px" :md="6">
              <a-form-model-item label="订单状态">
                <a-select
                  allowClear
                  placeholder="请选择"
                  :options="statusOptions"
                  v-model="queryForm.status"
                ></a-select>
              </a-form-model-item>
            </a-col>
            <a-col style="min-width: 320px" :md="6">
              <a-form-model-item label="结算时间">
                <a-range-picker v-model="queryForm.valid_period"></a-range-picker>
              </a-form-model-item>
            </a-col>
            <a-col style="min-width: 320px" class="table-query-action" :md="6">
              <a-form-model-item>
                <a-button type="primary" @click="handleQueryClick">查询</a-button>
                <a-button style="margin-left: 20px" @click="handleReset">重置</a-button>
                <a-button style="margin-left: 20px">
                  <a :href="exportUrl">导出</a>
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col style="min-width: 320px" :md="6">
              <a-form-model-item label="发件人">
                <a-input v-model="queryForm.name"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col style="min-width: 320px" :md="6">
              <a-form-model-item label="物流单号">
                <a-input v-model="queryForm.line_no"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <a-table
        row-key="id"
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1600 }"
      >
        <span slot="lineNo" slot-scope="text, record">
          <span style="color:red" @click="handleLinkOrder(record)">{{ record.line_no }}</span>
        </span>
        <span slot="amount" slot-scope="text, record">
          <span style="color:red" v-if="record.pick_date_is_expire">{{ record.pick_up_date }}</span>
          <span v-if="record.pick_date_is_expire == false">{{ record.pick_up_date }}</span>
        </span>
        <template slot="order_id" slot-scope="record">
          <!-- -1 => '已取消',
            1 => '未付款',
            2 => '已支付',
            3 => '已获准',
            4 => '已发出',
            5 => '到达目的地',
            6 => '已配送',
            7 => '已完成',
            8 => '退款中',
            9 => '已退款' -->
          <router-link :to="{ name: $routeName.orderDetail, query: { id: record.id } }">
            <p :style="record.status == 8 ? 'background: red;color: #fff' : ''">{{ record.order_id }}</p>
          </router-link>
        </template>
        <!--        <template slot="line_no" slot-scope="record">-->
        <!--          <router-link :to="{ name: $routeName.orderDetail, query: { id: record.id } }">-->
        <!--            <p style="color: red">{{ record.line_no }}</p>-->
        <!--          </router-link>-->
        <!--        </template>-->

        <template slot="action" slot-scope="record">
          <router-link :to="{ name: $routeName.orderDetail, query: { id: record.id } }">查看详情</router-link>
          <a-divider type="vertical" v-if="record.status == 1" />
          <a-popconfirm
            title="确认取消该订单吗"
            ok-text="是"
            cancel-text="否"
            @confirm="confirmCancel(record)"
            v-if="record.status == 1"
          >
            <a href="#" style="color: #ff4d4f">
              取消订单
            </a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </main-container>

  <router-view v-else></router-view>
</template>

<script>
import { mapState } from 'vuex';

import Order from '@/api/order';

const columns = [
  {
    title: '订单编号',
    key: 'order_id',
    scopedSlots: { customRender: 'order_id' },
  },
  {
    title: '订单来源',
    dataIndex: 'source',
  },
  {
    title: '发件人',
    dataIndex: 'username',
  },
  {
    title: '物流单号',
    dataIndex: 'line_no',
    scopedSlots: { customRender: 'lineNo' },
  },
  {
    title: '手机号',
    dataIndex: 'phone',
  },
  {
    title: '寄件城市',
    dataIndex: 'send_city',
  },
  {
    title: '收件城市',
    dataIndex: 'receive_city',
  },
  {
    title: '物流路线',
    dataIndex: 'service',
  },
  {
    title: '处理状态',
    dataIndex: 'status_text',
  },
  {
    title: '订单时间',
    dataIndex: 'create_time',
  },
  {
    title: '取件时间',
    dataIndex: 'pick_up_date',
    scopedSlots: { customRender: 'amount' },
  },
  {
    title: '金额',
    dataIndex: 'amount',
  },
  {
    title: '支付方式',
    dataIndex: 'pay_type',
  },
  {
    key: 'action',
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: 'OrderPurchase',

  data() {
    return {
      columns,
      loading: false,
      dataSource: [],
      queryForm: {
        order_id: undefined,
        status: undefined,
        valid_period: undefined,
        name: undefined,
        range: undefined,
        line_no: undefined,
      },
      queryFormRules: {},
      pagination: {
        current: 1,
        pageSize: 100,
        'show-size-changer': true,
        'show-total': total => `共 ${total} 条`,
      },
      statusOptions: [
        { value: 1, label: '待支付' },
        { value: 2, label: '已支付' },
        { value: 3, label: '已获准' },
        { value: 4, label: '已发出' },
        { value: 5, label: '到达目的地' },
        { value: 6, label: '已配送' },
        { value: 7, label: '已完成' },
        { value: -1, label: '已取消' },
        { value: 9, label: '已退款' },
      ],
      selectedRowKeys: [],

      activeIndex: 1,
      rangeQueryMap: {
        1: { range: 'new' }, // 新订单
        2: { status: 3 }, // 已获准
        3: { status: 4 }, // 已发出
        4: { status: 5 }, // 到达目的地
        5: { status: 6 }, // 已配送
        6: { status: 7 }, // 已完成
        7: { status: -1 }, // 已取消
        8: { status: 9 }, // 已退款
      },
      rangeTetx: '',
    };
  },
  computed: {
    ...mapState('order', ['orderCount']),
    isBasicRoute() {
      return this.$route.name === this.$routeName.orderList || this.$route.name === this.$routeName.memberOrderList;
    },

    exportUrl() {
      console.log(process.env.VUE_APP_API_BASE_URL);
      return `${process.env.VUE_APP_API_BASE_URL}/admin/i_lis/exportOrder?ids=${this.selectedRowKeys.join(',')}`;
    },

    userId() {
      return this.$route.query.user_id;
    },

    range() {
      return this.$route.query.range;
    },
  },

  mounted() {
    if (this.isBasicRoute) {
      this.loadOrderList();
      if (!this.userId) {
        this.$store.dispatch('order/loadOrderCount');
      }
    }
  },

  created() {
    this.rangeTetx = this.$route.query.range;
    this.loadOrderList();
  },

  methods: {
    handleLinkOrder(record) {
      window.open(process.env.VUE_APP_ORDER_URL + record.line_no);
    },
    handleQueryClick() {
      this.pagination.current = 1;
      this.loadOrderList(1);
    },

    loadRangeOrderList(index) {
      if (index == this.activeIndex) {
        index = '';
        this.queryForm.status = undefined;
        this.queryForm.range = undefined;
      } else if (index < 4) {
        this.queryForm.status = undefined;
      } else if (index > 3) {
        this.queryForm.range = undefined;
      }
      this.activeIndex = index;
      this.queryForm = {
        ...this.queryForm,
        ...this.rangeQueryMap[index],
      };

      this.pagination.current = 1;
      this.loadOrderList();
    },

    loadOrderList(isQuery) {
      let range = undefined;
      if (this.activeIndex == 1) {
        range = 'new';
      } else {
        range = undefined;
      }
      if (this.rangeTetx && this.rangeTetx === 'valid') {
        range = this.rangeTetx;
      }
      if (this.rangeTetx && this.rangeTetx === 'wu') {
        range = undefined;
      }
      this.loading = true;
      const format = 'YYYY-MM-DD';
      const { valid_period, ...params } = this.queryForm;
      if (isQuery) {
        range = undefined;
      }
      Order.orderList({
        ...params,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
        start: valid_period && valid_period[0].format(format),
        end: valid_period && valid_period[1].format(format),
        user_id: this.userId,
        range: range,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          for (var index in data.list) {
            if (data.list[index].line_no) {
              data.list[index].line_no = data.list[index].line_no[0];
            }
          }
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.loadOrderList();
    },

    handleReset() {
      this.queryForm = {
        order_id: undefined,
        status: undefined,
        valid_period: undefined,
        name: undefined,
      };
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    confirmCancel(record) {
      Order.orderCancel({ order_id: record.id }).then(res => {
        console.log(res);
        if (res.status == 'success') {
          this.$message.success('操作成功');
          this.loadOrderList();
          this.$store.dispatch('order/loadOrderCount');
        } else {
          this.$message.error('操作失败');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.status_list {
  margin-bottom: 20px;

  .item {
    margin-right: 20px;
  }
}
</style>
